var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRuble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 39,
    viewBox: "0 0 32 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41998 16.7924H6.91998V16.2924L6.91998 3.20756C6.91998 1.70513 8.11788 0.5 9.57987 0.5L20.8151 0.5C26.6994 0.5 31.5 5.36235 31.5 11.3539C31.5 17.3452 26.6992 22.2076 20.8151 22.2076H12.7398H12.2398V22.7076V26.0679V26.5679H12.7398H19.21C20.672 26.5679 21.8699 27.773 21.8699 29.2754C21.8699 30.7779 20.672 31.983 19.21 31.983H12.7398H12.2398V32.483V35.7924C12.2398 37.2949 11.0419 38.5 9.57987 38.5C8.11788 38.5 6.91998 37.2949 6.91998 35.7924V32.483V31.983H6.41998H3.15988C1.6979 31.983 0.5 30.7779 0.5 29.2754C0.5 27.773 1.6979 26.5679 3.15988 26.5679H6.41998H6.91998V26.0679L6.91998 22.7076V22.2076H6.41998H3.15988C1.6979 22.2076 0.5 21.0024 0.5 19.5C0.5 17.9976 1.6979 16.7924 3.15988 16.7924H6.41998ZM12.2398 16.2923V16.7923H12.7398H20.8151C23.781 16.7923 26.1802 14.3458 26.1802 11.3536C26.1802 8.36126 23.7808 5.91498 20.8151 5.91498H12.7398H12.2398V6.41498L12.2398 16.2923Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuble);
export default __webpack_public_path__ + "static/media/ruble.6d961e2a3b0f77905ac314000377e444.svg";
export { ForwardRef as ReactComponent };